export const MESSAGE_TYPES: { [key: string]: number } = {
  USER_TYPE: 0,
  SYSTEM_TYPE: 1,
  DATES_ARE_PROPOSED: 2,
  FEEDBACK_REQUIRED: 4,
  FEEDBACK_RECEIVED: 5,
  OFFER_MAKE: 10,
  RATING_REQUIRED: 99,
};
